import { useCallback } from 'react';
import type { JSX } from 'react';

import { Button } from '@change/ds-core-ui';
import { SignaturesIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core-react/i18n';

import { SECTION_ID_MAPPING } from '#src/app/pages/petitionDetails/shared/constants';
import { useScrollToSection } from '#src/app/pages/petitionDetails/shared/hooks';

import { useTracking } from '../embeddedSignForm/hooks';

import { ActionButtonWrapper } from './ActionButtonWrapper';
import { usePreloadMobileSignModal } from './MobileSignModal';

type Props = {
	sticky: boolean;
	visible: boolean;
};

export function MobileScrollToEmbeddedFormButtonContainer({ sticky, visible }: Props): JSX.Element | null {
	usePreloadMobileSignModal();

	const {
		actions: { scrollToSection },
	} = useScrollToSection();

	const { trackClick } = useTracking();

	const onClick = useCallback(() => {
		trackClick();

		scrollToSection(SECTION_ID_MAPPING.EMBEDDED_SIGN_FORM);
	}, [scrollToSection, trackClick]);

	return (
		// eslint-disable-next-line @change-corgi/require-data-qa-attribute
		<ActionButtonWrapper visible={visible} sticky={sticky}>
			<Button
				variant="primary"
				onClick={onClick}
				leadingIcon={<SignaturesIcon size="small" />}
				data-qa="mobile-scroll-to-embedded-form-button"
				data-testid="mobile-scroll-to-embedded-form-button"
				data-gtm="ga4-scroll-to-embedded-form-button"
				size="large"
				className="w-full max-w-none"
			>
				<div className="flex place-content-center place-items-center gap-3">
					<Translate value="corgi.petition_gamma.petition_sign.action" />
				</div>
			</Button>
		</ActionButtonWrapper>
	);
}
